import { Guid } from "@/types"

export enum Role {
    SuperAdmin = "SuperAdmin",
    TenantAdmin = "TenantAdmin",
    StockCoordinator = "StockCoordinator",
    ShippingCoordinator = "ShippingCoordinator",
    SalesAdmin = "SalesAdmin",
    Controller = "Controller",
}

export interface IGetUserRolesItemDto {
    userId: Guid
    roles: Role[]
}

export type GetUserRoles = IGetUserRolesItemDto[]

export default class UserRoles {
    items: Record<Guid, Role[]> // <userId, roles[]>

    constructor(dto: GetUserRoles) {
        this.items = dto.reduce((acc, entity) => {
            acc[entity.userId] = entity.roles
            return acc
        }, {})
    }
}

